/**
 * Shared operator list for condition configuration (branch node conditions
 * and loop-edge filter conditions).
 */

import type { ConditionOperator } from '../types/pipeline';
import type { FieldPath } from './nodeOutputSchema';

export interface ConditionOperatorOption {
  value: ConditionOperator;
  label: string;
  numericOnly?: boolean;
}

export const CONDITION_OPERATORS: ConditionOperatorOption[] = [
  { value: 'equals', label: 'Equals' },
  { value: 'not_equals', label: 'Not Equals' },
  { value: 'contains', label: 'Contains' },
  { value: 'greater_than', label: 'Greater Than', numericOnly: true },
  { value: 'less_than', label: 'Less Than', numericOnly: true },
  { value: 'exists', label: 'Exists' },
];

/**
 * Returns the operators applicable to a field of the given type, hiding
 * numeric-only comparisons (greater_than/less_than) for non-numeric fields.
 */
export function operatorsForFieldType(type?: FieldPath['type']): ConditionOperatorOption[] {
  return CONDITION_OPERATORS.filter(op => !op.numericOnly || type === 'number');
}
